import {EnvBaseConfig} from './environment.config';

const env = {
  cvsProdHost: ['www.cvs.com', 'www-beta.cvs.com', 't.cvs.com', 'm.cvs.com', 'es.cvs.com']
};

/* tslint:disable */
function isProd() {
  var host = window.location.host ;
  return env.cvsProdHost.indexOf(host) > -1 ;
}
// set the production environment to true
// export the new configuration
class EnvConfig extends EnvBaseConfig {
  constructor() {
    super();
    this.production = true;
  }
}

// export the new configuration
export const environment: any = { ...new EnvConfig() };
